var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "row mb-2" }, [
        _c("div", { staticClass: "col-12" }, [
          _c("label", [
            _vm._v(
              "\n                " +
                _vm._s(
                  _vm.resource(
                    "JourneyComposer_BrickSettingsTouchpoint_Custom_Conditions_Header"
                  )
                ) +
                "\n            "
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row mb-2" }, [
        _c("div", { staticClass: "col-12" }, [
          _c(
            "button",
            {
              staticClass: "btn btn-outline-secondary",
              attrs: { disabled: !_vm.canAddNewConditions },
              on: {
                click: function($event) {
                  return _vm.addCondition()
                }
              }
            },
            [
              _c("i", { staticClass: "fas fa-plus" }),
              _vm._v(
                " " + _vm._s(_vm.resource("Button_Add")) + "\n            "
              )
            ]
          )
        ])
      ]),
      _vm._v(" "),
      _vm.isLoading
        ? _c("div", { staticClass: "row mb-2" }, [
            _c("i", { staticClass: "loader fas fa-spinner fa-spin fa-2x" })
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.fields.length !== 0
        ? _vm._l(_vm.sortedValue, function(condition, index) {
            return _c("brick-custom-condition-field", {
              key: condition.id,
              ref: "fields",
              refInFor: true,
              attrs: {
                value: condition,
                "available-types": _vm.getSelectableTypes(condition.type),
                "is-selectable-dropdown-value": _vm.isSelectableDropdownValue
              },
              on: {
                input: function($event) {
                  _vm.updateCondition($event, _vm.value.indexOf(condition))
                },
                delete: function($event) {
                  return _vm.removeCondition(condition)
                }
              }
            })
          })
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }